import React, { useState } from "react";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import Title from "../Title/Title";
import Form from "../Form/Form";
import useForm from "../utils/hooks/useForm";
import { ControlledTextInput } from "../DataInput/TextInput/TextInput";
import { useToast } from "../Toast";
import { FilterValue, SaveFilterModalProps } from "./types";

/**
 * @deprecated part of the old FilterDrawer pattern. Use new FilterArea pattern
 * directly the apps instead.
 */
const SaveFilterModal = ({
  isOpen,
  onClose,
  onSave,
  onSaveFilter,
}: SaveFilterModalProps) => {
  const [isSaving, setIsSaving] = useState(false);

  const form = useForm();
  const { toast } = useToast();

  const handleSave = async (formValues: FilterValue) => {
    try {
      setIsSaving(true);
      await onSaveFilter(formValues?.name);

      toast.push({
        intent: "success",
        description: `Successfully saved filter ${formValues?.name}.`,
      });

      onSave();
      setIsSaving(false);
      onClose();
    } catch (err) {
      setIsSaving(false);
      toast.push({
        intent: "error",
        description: `Unable to save filter ${formValues?.name}.`,
      });
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
    >
      <Form
        {...form}
        onSubmit={handleSave}
      >
        <Modal.Header>
          <Title>Save Filter</Title>
        </Modal.Header>

        <Modal.Body>
          <p>Save the filter to reuse it on this page.</p>
          <ControlledTextInput
            label="Filter"
            name="name"
            placeholder="My Filter Name"
            isRequired
            isDisabled={isSaving}
          />
        </Modal.Body>

        <Modal.Footer className="clearfix modal-footer">
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            type="submit"
            disabled={isSaving}
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SaveFilterModal;
